import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../ui/dropdown-menu";
import IconProvider from "@/components/ui/IconProvider";

import { usePlatformTranslation } from '@/hooks/usePlatformTranslation';
interface BackgroundColorDropdownProps {
  onFormat: (command: string, value?: string) => void;
}

const colorOptions = [
  // Yellow
  { value: '#C67A00', label: 'Yellow Dark' },
  { value: '#F4B208', label: 'Yellow' },
  { value: '#FFE5A4', label: 'Yellow Light' },
  // Green
  { value: '#228354', label: 'Green Dark' },
  { value: '#1BBF6F', label: 'Green' },
  { value: '#C2F6DD', label: 'Green Light' },
  // Aqua
  { value: '#02A893', label: 'Aqua Dark' },
  { value: '#01B2BE', label: 'Aqua' },
  { value: '#8CE7ED', label: 'Aqua Light' },
  // Blue
  { value: '#2B6AC1', label: 'Blue Dark' },
  { value: '#3589FF', label: 'Blue' },
  { value: '#BED9FF', label: 'Blue Light' },
  // Purple
  { value: '#4A1AC5', label: 'Purple Dark' },
  { value: '#6E35FF', label: 'Purple' },
  { value: '#DFD2FF', label: 'Purple Light' },
  // Violet
  { value: '#762BAF', label: 'Violet Dark' },
  { value: '#A735FF', label: 'Violet' },
  { value: '#ECD3FF', label: 'Violet Light' },
  // Red
  { value: '#BC1C21', label: 'Red Dark' },
  { value: '#F23030', label: 'Red' },
  { value: '#FFD7D7', label: 'Red Light' },
];

export const BackgroundColorDropdown = ({ onFormat }: BackgroundColorDropdownProps) => {
  const { t } = usePlatformTranslation();
  const handleBackgroundSelect = (value: string) => {
    onFormat('hiliteColor', value);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-8 px-2 hover:bg-gray-100 text-gray-700 hover:text-gray-900 border-r border-gray-200"
        >
          <IconProvider iconstring="fa-highlighter-line" size={14} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56 p-2">
        <div className="grid grid-cols-7 gap-1">
          {/* No Color Option */}
          <button
            onClick={() => handleBackgroundSelect('transparent')}
            className="w-6 h-6 rounded border border-gray-300 bg-white dark:bg-gray-800 hover:scale-110 transition-transform cursor-pointer flex items-center justify-center"
            title={t('platform.editor.bubblemenuhelpers.no_color')}
          >
            <IconProvider iconstring="fa-times" size={8} className="text-muted-foreground" />
          </button>
          
          {colorOptions.map((color) => (
            <button
              key={color.value}
              onClick={() => handleBackgroundSelect(color.value)}
              className="w-6 h-6 rounded border border-gray-300 hover:scale-110 transition-transform cursor-pointer"
              style={{ backgroundColor: color.value }}
              title={color.label}
            />
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}; 